export const FLOW_TYPE_USED_CAR_WITHOUT_OC = "FLOW_TYPE_USED_CAR_WITHOUT_OC";
export const FLOW_TYPE_USED_CAR_WITH_OC = "FLOW_TYPE_USED_CAR_WITH_OC";
export const FLOW_TYPE_USED_CAR_THIRD_PARTY_PLAN = "FLOW_TYPE_USED_CAR_THIRD_PARTY_PLAN";
export const FLOW_TYPE_NEW_CAR = "FLOW_TYPE_NEW_CAR";

// Personal Accident Flow Types
export const FLOW_TYPE_PERSONAL_ACCIDENT_STANDARD = "FLOW_TYPE_PERSONAL_ACCIDENT_STANDARD";

// Personal Cyber Flow Types
export const FLOW_TYPE_PERSONAL_CYBER_STANDARD = "FLOW_TYPE_PERSONAL_CYBER_STANDARD";

export const STEP_NAME_START = "start";
export const STEP_NAME_CAR = "car";
export const STEP_NAME_PLAN = "plan";
export const STEP_NAME_AD_DONS = "ad_dons";
export const STEP_NAME_UPLOAD = "upload";
export const STEP_NAME_PAY = "pay";

// Personal Accident Step Names
export const STEP_NAME_PERSONAL_INFO = "personal_info";
export const STEP_NAME_COVERAGE = "coverage";
export const STEP_NAME_REVIEW = "review";

// Personal Cyber Step Names
export const STEP_NAME_PLAN_SELECTION = "plan_selection";

const insurance_start_step = {
    name: STEP_NAME_START,
    substeps: [
        'basic_info',
        'documents_ready',
    ]
};

export const new_motor_insurance_flow = {
    [FLOW_TYPE_USED_CAR_WITHOUT_OC]: [
        insurance_start_step,
        {
            name: STEP_NAME_CAR,
            substeps: [
                'about_car', // is brand new? ownership exists?
                'car_info_number_plate', // plate number with gdt
                'new_car_detail', // car info page
                'car_financing', // sum insured and banks
            ]
        },
        {
            name: STEP_NAME_PLAN,
            substeps: [
                'choose_plan',
            ]
        },
        {
            name: STEP_NAME_AD_DONS,
            substeps: [
                'enhance_coverage',
            ]
        },
        {
            name: STEP_NAME_UPLOAD,
            substeps: [
                'upload_req_docs',
            ]
        },
        {
            name: STEP_NAME_PAY,
            substeps: [
                'review_and_confirm',
                'payment_method',
                'payment_congratulations'
            ]
        },
    ],
    [FLOW_TYPE_USED_CAR_WITH_OC]: [
        insurance_start_step,
        {
            name: STEP_NAME_CAR,
            substeps: [
                'about_car',
                'car_info_confirm',
                // 'new_car_detail', // car info page
                'car_financing',
            ]
        },
        {
            name: STEP_NAME_PLAN,
            substeps: [
                'choose_plan',
            ]
        },
        {
            name: STEP_NAME_AD_DONS,
            substeps: [
                'enhance_coverage',
            ]
        },
        {
            name: STEP_NAME_UPLOAD,
            substeps: [
                'upload_req_docs',
            ]
        },
        {
            name: STEP_NAME_PAY,
            substeps: [
                'review_and_confirm',
                'payment_method',
                'payment_congratulations'
            ]
        },
    ],
    [FLOW_TYPE_USED_CAR_THIRD_PARTY_PLAN]: [
        insurance_start_step,
        {
            name: STEP_NAME_CAR,
            substeps: [
                'about_car',
                'car_info_confirm',
                'car_financing',
            ]
        },
        {
            name: STEP_NAME_PLAN,
            substeps: [
                'choose_plan',
            ]
        },
        {
            name: STEP_NAME_AD_DONS,
            substeps: [
                'enhance_coverage',
            ]
        },
        {
            name: STEP_NAME_UPLOAD,
            substeps: [
                // 'upload_photos_of_car',
                'upload_req_docs',
            ]
        },
        {
            name: STEP_NAME_PAY,
            substeps: [
                'review_and_confirm',
                'payment_method',
                'payment_congratulations'
            ]
        },
    ],
    [FLOW_TYPE_NEW_CAR]: [
        insurance_start_step,
        {
            name: STEP_NAME_CAR,
            substeps: [
                'about_car',
                'new_car_detail',
                'car_financing',
            ]
        },
        {
            name: STEP_NAME_PLAN,
            substeps: [
                'choose_plan',
            ]
        },
        {
            name: STEP_NAME_AD_DONS,
            substeps: [
                'enhance_coverage',
            ]
        },
        {
            name: STEP_NAME_UPLOAD,
            substeps: [
                // 'upload_photos_of_car',
                'upload_req_docs',
            ]
        },
        {
            name: STEP_NAME_PAY,
            substeps: [
                'review_and_confirm',
                'payment_method',
                'payment_congratulations'
            ]
        },
    ],
};

// Personal Accident Insurance Flow
const personal_accident_start_step = {
    name: STEP_NAME_START,
    substeps: [
        'basic_info',
        'documents_ready',
    ]
};

export const new_personal_accident_flow = {
    [FLOW_TYPE_PERSONAL_ACCIDENT_STANDARD]: [
        personal_accident_start_step,
        {
            name: STEP_NAME_PERSONAL_INFO,
            substeps: [
                'required_information',
                'contact_details',
            ]
        },
        {
            name: STEP_NAME_PAY,
            substeps: [
                'review_and_confirm',
            ]
        },
    ],
};

// Personal Cyber Insurance Flow
const personal_cyber_start_step = {
    name: STEP_NAME_START,
    substeps: [
        'basic_info',
        'documents_ready',
    ]
};

export const new_personal_cyber_flow = {
    [FLOW_TYPE_PERSONAL_CYBER_STANDARD]: [
        personal_cyber_start_step,
        {
            name: STEP_NAME_PLAN_SELECTION,
            substeps: [
                'choose_plan',
                'contact_details',
            ]
        },
        {
            name: STEP_NAME_PAY,
            substeps: [
                'review_and_confirm',
            ]
        },
    ],
};
